module fdm.flightLegs {

    import IQueryAction = dg.domain.queries.IQueryAction;

    export interface Parameter {
        name: string;
        generalParameter: string;
        unit: string;
        range: dg.domain.model.Range<number>;
        activeStateValue?: number;
        axisTitle: string;
        color: string;
    }

    interface ParameterValue {
        [index: string]: () => number;
    }

    interface ParameterValuesCache {
        cockpit: boolean;
        result: iteraFDM.domain.flightLegs.FlightTraceInfo;
    }

    export class ParameterValuesService implements dg.actions.IQueryExecutionStrategy {

        private resultCache: ParameterValuesCache;
        private flightLegId: string;
        private flightEventId: string;

        private lastParameters: string[];

        constructor(private actionService: dg.actions.ActionService, private $q: ng.IQService) {
        }

        getQuery(link: dg.restfulApi.Link): ng.IPromise<IQueryAction> {
            return this.actionService.getActionFromLink(link, { 'parameters.id': this.lastParameters});
        }

        executeQuery(qqq: IQueryAction) {
            let deferred = this.$q.defer<any>();
            let query = <iteraFDM.domain.flightLegs.FlightTraceQuery>qqq;
            this.lastParameters = query.parameters.map(p => p.id); 
            query = dgUtils.ObjectHelperService.mergeDeep({}, query);

            if (query && query.parameters) {

                if (!this.canUseCache(query)) {
                    this.clearParameterCache();
                    this.flightLegId = query.aggregateId;
                    this.flightEventId = query.flightEventId;
                }

                this.requestParameters(query).then(result => {
                    this.mergeResultToCache(query, result);

                    let clonedResult = { ...this.resultCache.result };
                    deferred.resolve(clonedResult);
                }, deferred.reject);
            }

            return deferred.promise;
        }

        private mergeResultToCache(query: iteraFDM.domain.flightLegs.FlightTraceQuery, result: iteraFDM.domain.flightLegs.FlightTraceInfo) {
            if (result) {

                if (!this.resultCache) {
                    this.resultCache = {
                        cockpit: query.cockpit,
                        result: result
                    };
                } else {
                    const mergedParameters = this.mergeParameters(this.resultCache.result.parameters, result.parameters);
                    const mergedParameterValues = this.mergeParameterValues(mergedParameters, this.resultCache.result.parameterValues, result.parameterValues);
                    //this.resultCache.result = dgUtils.ObjectHelperService.mergeDeep(this.resultCache.result, result);
                    this.resultCache.result.parameters = mergedParameters;
                    this.resultCache.result.parameterValues = mergedParameterValues;
                    this.resultCache.cockpit = query.cockpit;
                    this.resultCache.result.navDataString = result.navDataString;
                    this.resultCache.result.metarDataString = result.metarDataString;
                }
            }
        }

        private canUseCache(query: iteraFDM.domain.flightLegs.FlightTraceQuery) {
            return query.flightEventId == this.flightEventId && query.aggregateId == this.flightLegId;
        }

        private mergeParameters(parameters: Array<Parameter>, newParameters: Array<Parameter>) {
            if (parameters) {
                newParameters.forEach((p: Parameter) => {
                    let parameterInCache = parameters.find(cachedParameter => cachedParameter.name === p.name);
                    if (!parameterInCache) {
                        parameters.push(p);
                    }
                });
            } else {
                parameters = newParameters;
            }

            return parameters;
        }

        private mergeParameterValues(parameters: Array<Parameter>, cachedParameterValues: Array<ParameterValue>, newParameterValues: Array<ParameterValue>) {
            //cachedParameterValues = dgUtils.ObjectHelperService.mergeDeep({}, cachedParameterValues);
            if (!cachedParameterValues || cachedParameterValues.length === 0) {
                //if ((!cachedParameterValues && cachedParameterValues.length === 0) || !parameters) {
                cachedParameterValues = newParameterValues;
            }
            else if (parameters && cachedParameterValues.length === newParameterValues.length) {
                for (let i = 0; i < cachedParameterValues.length; i += 1) {
                    parameters.forEach(parameter => {
                        let parameterName = parameter.name;
                        if (!cachedParameterValues[i].hasOwnProperty(parameterName)
                            && newParameterValues[i].hasOwnProperty(parameterName)) {
                            cachedParameterValues[i][parameterName] = newParameterValues[i][parameterName];
                        };
                    });
                }
            }

            return cachedParameterValues;
        }

        private getParametersToRequest(parameters: dg.domain.model.StringDomainModelRefInfo[]) {
            // Returns new parameters from query that need to be requested

            let parametersToReqeust = parameters;
            if (this.resultCache && this.resultCache.result.parameters) {
                parametersToReqeust = [];
                parameters.forEach((param) => {
                    if (!this.resultCache.result.parameters.find((p: Parameter) => p.name === param.id)) {
                        parametersToReqeust.push(param);
                    }
                });
            } 
           
            return parametersToReqeust; 
        }

        private requestParameters(query: iteraFDM.domain.flightLegs.FlightTraceQuery) {
            let deferred = this.$q.defer<iteraFDM.domain.flightLegs.FlightTraceInfo>();

            query.parameters = this.getParametersToRequest(query.parameters);
            if (query.cockpit && this.resultCache.cockpit) {
                query.cockpit = false;
            }

            if (query.parameters.length > 0 || query.cockpit) {
                this.actionService.executeQuery(query).then((result: iteraFDM.domain.flightLegs.FlightTraceInfo) => {
                    deferred.resolve(result);
                });
            }
            else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        private clearParameterCache() {
            this.resultCache = null;
        }
    }

    angular.module('fdm.flightLegs')
        .service('parameterValuesService', ParameterValuesService);
}
